import { React } from '_core';

import FixedCost from './fixed-costs';
import { FixedCostContextProvider } from './fixed-costs-context';

const FixedCosts = () => {
  return (
    <FixedCostContextProvider>
      <FixedCost />
    </FixedCostContextProvider>
  );
};

export default FixedCosts;
